import { useParams } from "react-router-dom";
import Box from "@/elements/Box";
import Grafo from "../Grafo";

function AziendaGrafoPage() {
  const { id } = useParams<{ id: string }>();
  const aziendaId = parseInt(id || "0");

  return (
    <Box p={1}>
      <Box sx={{ height: "calc(100vh - 200px)", width: "100%" }}>
        <Grafo nodoId={aziendaId}/>
      </Box>
    </Box>
  );
}

export default AziendaGrafoPage;